import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormGroup } from '@angular/forms';
import { NotificationService } from '../../../../shared/services/notifications.service';
import { ModalService } from '../../../../shared/modules/modal/modal.service';
import { CompSearchService } from '../../../../shared/services/comp-search.service';

import { ClosableModalWithErrorResponseModel } from '../../../../shared/components/base/closable-modal-with-error-response-model';
import { CompSearchData, TuneCompSearchModalDeletePayload } from '../../../../shared/models';

@Component({
  selector: 'delete-comp-search-modal',
  templateUrl: './delete-comp-search-modal.component.html',
  styleUrls: ['../tune-comparable-search.component.css']
})
export class DeleteCompSearchModalComponent extends ClosableModalWithErrorResponseModel<any> implements OnInit {
  data: TuneCompSearchModalDeletePayload;
  compSearches: CompSearchData[];
  deleteCompSearchForm: FormGroup;
  confirmationInput: string;
  confirmationText: string;
  deletingCompSearch: boolean = false;

  constructor(
  protected notificationService: NotificationService,
  protected modalService: ModalService,
  private _compSearchService: CompSearchService,
  private _formBuilder: FormBuilder,
  ) {
    super(notificationService, modalService);
    this.confirmationInput = '';
    this.confirmationText = 'Fiona';
  }

  ngOnInit(): void {
    this.loadExistingCompSearches();
    this.createForm();
  }
  
  loadExistingCompSearches(): void {
    this._compSearchService.getSavedCompSearches(this.data.tenantId).subscribe(({ data }) => this.compSearches = data);
  }

  private createForm(): void {
    this.deleteCompSearchForm = this._formBuilder.group({
      compSearch: ['', [Validators.required]],
      confirmation: ['', [Validators.required]]
    },
    {
      validator: this.IsValidConfirmationInput(this.confirmationText)
    });
  }

  getCompSearchFormControl(): AbstractControl { return this.deleteCompSearchForm.get('compSearch'); }
  getConfirmationFormControl(): AbstractControl { return this.deleteCompSearchForm.get('confirmation'); }

  IsValidConfirmationInput(confirmation: string): Function {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls.confirmation;
      control.value !== confirmation ? control.setErrors({ confirmation: true }) : control.setErrors(null);
    };
  }

  validateFormAndDelete(): void {
    if (this.isValidForm()) {
      this.deleteCompSearch();
    }
  }

  isValidForm(): boolean {
    return this.deleteCompSearchForm.valid;
  }

  private deleteCompSearch(): void {
    const { compSearchLocalLibraryId, tenantId } = this.getCompSearchFormControl().value;

    this.deletingCompSearch = true;
    this._compSearchService.deleteCompSearch(compSearchLocalLibraryId, tenantId).subscribe(() => {
      this.deletingCompSearch = false;
      this.success();
      this.closeAllModals();
    });
  }

  exitModal(): void {
    this.closeAllModals();
  }
}
